<template>
  <!-- Main content -->
  <section class="content">
    <div class="btn-box">
      <el-form :inline="true">
        <el-form-item label="用户user_id：">
          <el-input v-model="uid" placeholder="请输入用户user_id"></el-input>
        </el-form-item>
        <el-form-item label="订单号：">
          <el-input v-model="orderId" placeholder="请输入订单号"></el-input>
        </el-form-item>
        <el-form-item label="平台类型：">
          <el-select v-model="type">
            <el-option
              v-for="item in typeList"
              :key="item.name"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="订单状态：">
          <el-select v-model="status">
            <el-option
              v-for="item in statusList"
              :key="item.name"
              :label="item.name"
              :value="item.type"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="下单开始时间：">
          <el-date-picker
            v-model="order_pay_time_start"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="下单开始时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="下单结束时间：">
          <el-date-picker
            v-model="order_pay_time_end"
            type="datetime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="下单结束时间"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="父订单号：">
          <el-input
            v-model="parent_order_sn"
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="seach(1)">搜索</el-button>
        </el-form-item>
      </el-form>
    </div>
    <el-table v-loading="loading" :data="mtList" border>
      <el-table-column
        fixed
        prop="parent_order_sn"
        label="父订单号"
        width="230"
      >
      </el-table-column>
      <el-table-column fixed prop="order_sn" label="订单编号" width="230">
      </el-table-column>
      <el-table-column fixed label="订单类型" width="120">
        <template slot-scope="scope">
          <span>
            {{ scope.row.order_type | type }}
          </span>
        </template>
      </el-table-column>
      <el-table-column fixed label="用户user_id(user_key)" width="200">
        <template slot-scope="scope">
          {{ scope.row.user_id }} ( {{ scope.row.user_key }} )
        </template>
      </el-table-column>
      <el-table-column
        prop="item_title"
        label="店铺名称"
        width="150"
      ></el-table-column>
      <el-table-column
        label="商品价格"
        prop="pay_amount"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="platform_commission"
        label="商品佣金"
        width="100"
      ></el-table-column>
      <el-table-column
        prop="user_commission"
        label="用户佣金"
        width="100"
      ></el-table-column>
      <el-table-column label="下单时间">
        <template slot-scope="scope">
          {{ scope.row.order_time | dateTime }}
        </template>
      </el-table-column>
      <el-table-column label="结算时间">
        <template slot-scope="scope">
          {{ scope.row.user_settled_time | dateTime }}
        </template>
      </el-table-column>
      <el-table-column label="订单状态">
        <template slot-scope="scope">
          <span
            :class="
              scope.row.status == 1
                ? 'green'
                : scope.row.status == 3
                ? 'blue'
                : scope.row.status == 4
                ? 'warn'
                : scope.row.status == 5 ||
                  scope.row.status == 6 ||
                  scope.row.status == 7
                ? 'red'
                : ''
            "
          >
            {{ scope.row.status | status }}
          </span>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right">
        <template slot-scope="scope">
          <el-button
            type="primary"
            size="mini"
            @click="alterDialog(scope.row)"
            v-if="scope.row.status == 1 || scope.row.status == 2"
            >修改</el-button
          >
          <el-button
            type="danger"
            size="mini"
            @click="settlement(scope.row.order_id)"
            v-if="scope.row.status == 1"
            >结算</el-button
          >
        </template>
      </el-table-column>
    </el-table>
     <el-dialog
      title="修改"
      :visible.sync="dialog"
      :close-on-click-modal="false"
    >
      <el-form>
        <el-form-item label="用户user_id">
          <el-input v-model="unionid" autocomplete="off"></el-input>
        </el-form-item>
        <el-form-item label="佣金">
          <el-input v-model="user_commission" autocomplete="off"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialog = false">取 消</el-button>
        <el-button type="primary" @click="alter">确 定</el-button>
      </div>
    </el-dialog>
    <el-pagination
      background
      layout="total, sizes,prev, pager, next,jumper"
      :total="total"
      @size-change="sizeChange"
      @current-change="currentChange"
    >
    </el-pagination>
  </section>
  <!-- /.content -->
</template>

<script>
let common = JSON.parse(window.localStorage.getItem("common"));
import * as api from "@/config/api";
export default {
  name: "mtOrder",
  components: {},

  data() {
    return {
      mtList: [],
      total: 0,
      page: 1,
      pagesize: 10,
      status: "",
      orderId: "",
      uid: "",
      type: "",
      order_pay_time_start: "",
      order_pay_time_end: "",
      parent_order_sn: "",
      loading: true,
      // typeList: [...[{
      //     type: '',
      //     name: '全部'
      // }], ...common.meituan_order_type_filter_list],
      typeList: [
        ...[
          {
            type: "",
            name: "全部",
          },
        ],
        ...[
          {
            type: "5",
            name: "美团联盟",
          },
          {
            type: "8",
            name: "美团到店",
          },
        ],
      ],
      statusList: common.order_status_list,
      dialog: false,
      order_id: "",
      unionid: "",
      user_commission: "",
    };
  },
  watch: {},
  filters: {
    status(val) {
      let name = "";
      if (JSON.stringify(common.order_status_list).indexOf(val) != -1) {
        common.order_status_list.map((a, index) => {
          if (val === a.type) {
            name = a.name;
          }
        });
      }
      return name;
    },
    type(val) {
      let name = "";
      if (JSON.stringify(common.meituan_order_type_list).indexOf(val) != -1) {
        common.meituan_order_type_list.map((a, index) => {
          if (val === a.type) {
            name = a.name;
          }
        });
      }
      return name;
    },
    compare(val) {
      return val === 1 ? "是" : "否";
    },
    dateTime(val) {
      let day = new Date(Number(val) * 1000);
      if (Number(val) === 0) {
        return "";
      }
      return (
        day.getFullYear() +
        "-" +
        `${
          day.getMonth() + 1 < 10
            ? "0" + (day.getMonth() + 1)
            : day.getMonth() + 1
        }` +
        "-" +
        `${day.getDate() < 10 ? "0" + day.getDate() : day.getDate()}` +
        " " +
        `${day.getHours() < 10 ? "0" + day.getHours() : day.getHours()}` +
        ":" +
        `${day.getMinutes() < 10 ? "0" + day.getMinutes() : day.getMinutes()}` +
        ":" +
        `${day.getSeconds() < 10 ? "0" + day.getSeconds() : day.getSeconds()}`
      );
    },
  },
  mounted() {
    this.getMtOrderList();
  },
  methods: {
    settlement(id) {
      this.$confirm("请确定是否结算该订单", "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          api.meituanOrderSettlement(
            {
              order_id: id,
            },
            (res) => {
              this.$message({
                type: "success",
                message: "结算成功!",
              });
              this.getMtOrderList();
            }
          );
        })
        .catch(() => {});
    },
    alterDialog({ order_id, user_id, user_commission }) {
      this.order_id = order_id;
      this.unionid = user_id;
      this.user_commission = user_commission;
      this.dialog = true;
    },
    alter() {
      api.meituanOrderUpdateItem(
        {
          order_id: this.order_id,
          user_id: this.unionid,
          user_commission: this.user_commission,
        },
        (res) => {
          console.log(res);
          this.$message({
            type: "success",
            message: res.msg,
          });
          this.dialog = false;
          this.seach(1);
        },
        (err) => {
          console.log(err);
        }
      );
    },
    close() {
      this.show = false;
      this.getMtOrderList();
    },
    getMtOrderList(page, size) {
      this.loading = true;
      api.getMtOrderList(
        {
          user_id: this.uid,
          status: this.status,
          // order_type: this.type,
          platform: this.type,
          order_sn: this.orderId,
          order_pay_time_start: this.order_pay_time_start,
          order_pay_time_end: this.order_pay_time_end,
          parent_order_sn: this.parent_order_sn,
          page: page ? page : this.page,
          pagesize: size ? size : this.pagesize,
        },
        (res) => {
          page && (this.page = page)
          this.mtList = res.data.list;
          this.total = Number(res.data.count);
          this.loading = false;
        }
      );
    },
    sizeChange(val) {
      this.pagesize = val;
      this.getMtOrderList();
    },
    currentChange(val) {
      this.page = val;
      this.getMtOrderList();
    },
    seach(page, size) {
      this.getMtOrderList(page, size);
    },
  },
};
</script>
<style scoped>
.cell {
  text-align: center;
}

.btn-box {
  text-align: left;
  margin-bottom: 20px;
}

img {
  width: 150px;
}

.red {
  color: #f56c6c;
}

.blue {
  color: #409eff;
}

.green {
  color: #67c23a;
}

.warn {
  color: #e6a23c;
}
</style>